
import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'
import Chart from 'chart.js'
import { Doughnut, mixins } from 'vue-chartjs'

@Component
export default class DoughnutGraph extends Mixins(Doughnut, mixins.reactiveProp) {
  @Prop() public chartData: any
  @Prop() public chartOptions: any

  mounted () {
    this.renderChart(this.chartData, this.chartOptions)
  }

  /* chartjsの関数を定義 */
  public renderChart!: (chartData: any, options: any) => void
}
